module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Semibold.7c4bbc01.woff";